import { useState } from "react";
import { hotTags } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

const chips = ["全部标签", "商业", "消费", "娱乐", "科技", "职场"];

export default function TagWall() {
  const [active, setActive] = useState("全部标签");
  const [picked, setPicked] = useState<string[]>([]);

  const toggle = (name: string) => {
    setPicked((p) => (p.includes(name) ? p.filter((x) => x !== name) : [...p, name]));
  };

  return (
    <section id="tags" className="scroll-mt-24 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <SectionHead
          kicker="price-tag-3-line"
          title="话题墙 · 按兴趣切入"
          sub="把争议、求证与跟进话题做成标签，点开即可跳到对应内容集合。"
        />

        <div className="mb-5 flex flex-wrap items-center gap-2">
          {chips.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={
                active === c
                  ? "whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-sm text-background-50"
                  : "whitespace-nowrap rounded-full bg-background-50 px-4 py-1.5 text-sm text-foreground-600 hover:bg-background-200"
              }
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4">
          {hotTags.map((t) => {
            const on = picked.includes(t.name);
            return (
              <button
                key={t.name}
                onClick={() => toggle(t.name)}
                className={
                  "group flex items-center justify-between gap-3 rounded-lg border px-3 py-2 text-left transition-colors " +
                  (on
                    ? "border-primary-300 bg-primary-50"
                    : "border-background-200 bg-background-50 hover:border-accent-300")
                }
              >
                <span className="inline-flex items-center gap-1.5">
                  {on ? (
                    <i className="ri-checkbox-circle-fill text-primary-500" aria-hidden="true" />
                  ) : (
                    <i
                      className="ri-price-tag-3-line text-foreground-400 group-hover:text-accent-600"
                      aria-hidden="true"
                    />
                  )}
                  <span className="whitespace-nowrap text-sm text-foreground-800">{t.name}</span>
                </span>
                <span className="font-display text-xs text-foreground-400">{t.count}</span>
              </button>
            );
          })}
        </div>

        {picked.length > 0 && (
          <p className="mt-4 text-xs text-foreground-500">
            已加入关注：{picked.join("、")}（演示交互，不接入真实检索）
          </p>
        )}
      </div>
    </section>
  );
}